var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.orders),callback:function ($$v) {_vm.orders=$$v},expression:"orders"}}),_c('div',{attrs:{"id":"flaggedOrdersPaging"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }